if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.freeSwatch = false;
        this.form = this.querySelector('form');
        if(this.form.querySelector('[name=id]')) {
          this.form.querySelector('[name=id]').disabled = false; 
        }
        if(this.dataset.freeSwatch && this.dataset.freeSwatch == 'true') {
          this.freeSwatch = true;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if(this.freeSwatch) {
          let variantList = [];
          this.form.querySelectorAll("input[name='ids[]']:checked").forEach(checkboxElement => {
            variantList.push(checkboxElement.value);
          });
          const cartDrawer = this.cart;
          if(variantList.length) {
            fetch('/cart.js', {
              method: 'GET'
            })
            .then(response => {
              return response.json();
            })
            .then(cart => {
              const availableSwatches = variantList.filter(variantId => cart.items.findIndex(item => item.id == variantId) < 0);

              if(availableSwatches.length > 0) {
                let formData = {
                 'items': [],
                 'sections': cartDrawer.getSectionsToRender().map((section) => section.id),
                  'sections_url': window.location.pathname
                };
                availableSwatches.forEach(availableItem => {
                  formData.items.push({
                    'id': availableItem,
                    'quantity': 1
                  })
                });

                fetch(`/cart/add.js`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(formData)
                })
                .then((response) => response.json())
                .then((response) => {
                  cartDrawer.renderContents(response);
                })
                .catch((e) => {
                  console.error(e);
                })
              } else {
                alert("Only 1 swatch per color allowed");
                this.form.querySelectorAll("input[name='ids[]']:checked").forEach(checkboxElement => {
                  checkboxElement.checked = false;
                });
                this.submitButton.setAttribute('aria-disabled', true);
              }
            })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
          } else {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
        } else {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
  
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              //tracking google analytics
              if(dataLayer) {                
                dataLayer.push({
                  event: "add_to_cart",
                  eventModel: {
                    ecomm_prodid: `shopify_US_${ response.product_id }_${ response.id }`,
                    ecomm_totalvalue: response.final_line_price / 100,
                    ecomm_pagetype: "cart",
                    value: response.final_line_price / 100,
                    currency: "USD",
                    items: [
                      {
                        id: `${ response.id }`,
                        name: `${ response.product_title }`,
                        brand: `${ response.vendor }`,
                        category: ``,
                        price: `${ response.price / 100 }`,
                        quantity: `${ response.quantity }`,
                        variant: `${ response.variant_title }`
                      }
                    ]
                  }
                })                
              }

              console.log(dataLayer);
  
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            }); 
        }        
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
